module.exports = __webpack_public_path__ + "static/img/books.88f2f94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/books.jpg
// module id = uohW
// module chunks = 171